<template>
    <div class="d-flex justify-center mt-12 page-text--lg font-weight-bold primary--text">
        <template v-if="disabled">
            <span> 필수 입력 필드가 {{ toDo }} 개 남았습니다. ({{ done }}/{{ total }}) </span>
        </template>
        <template v-else>
            <span> 필수 필드를 모두 입력하셨습니다. ({{ done }}/{{ total }}) </span>
        </template>
    </div>
</template>

<script>
import { EMPLOYMENT_FIELD_TYPES, initEmploymentContract } from "@/assets/variables";

export default {
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        form: { type: Object, default: initEmploymentContract },
    },
    computed: {
        /** @type {import('vue').ComputedOptions<import('@/assets/variables').Employment_Field[]>} */
        array() {
            return this.form.fields_employee.filter(({ type, isRequired }) => isRequired && type != EMPLOYMENT_FIELD_TYPES.FILE.value);
        },
        total() {
            return this.array.length;
        },
        done() {
            return this.array.reduce((sum, item) => {
                switch (item.type) {
                    case EMPLOYMENT_FIELD_TYPES.CBOX.value: {
                        if (item.data) sum += 1;
                        break;
                    }
                    case EMPLOYMENT_FIELD_TYPES.DATE.value: {
                        if (item.data) sum += 1;
                        break;
                    }
                    case EMPLOYMENT_FIELD_TYPES.SIGN.value: {
                        if (item.img) sum += 1;
                        break;
                    }
                    case EMPLOYMENT_FIELD_TYPES.TEXT.value: {
                        if (item.data) sum += 1;
                        break;
                    }
                }
                return sum;
            }, 0);
        },
        toDo() {
            return this.total - this.done;
        },
        disabled() {
            return 0 < this.toDo;
        },
    },
    mounted() {
        this.emit();
    },
    watch: {
        disabled() {
            this.emit();
        },
    },
    methods: {
        emit() {
            this.$emit("input", this.disabled);
        },
    },
};
</script>

<style></style>
